// ═══════════════════════════════════════════════════════════════════════════════
// Módulo: Financiamento — Serviço de Ranking (média global)
// ═══════════════════════════════════════════════════════════════════════════════

import { supabase } from '@/integrations/supabase/client';

export interface RankingGlobal {
  contract_id: string;
  contrato_nome: string;
  contratada: string;
  cluster_id: string | null;
  score_risco: number | null;
  nivel_criticidade: string | null;
  tendencia: string | null;
  prob_atraso_mc: number | null;
}

/** Fetch global risk ranking with pagination */
export async function fetchGlobalRanking(limit = 500, offset = 0) {
  const { data, error } = await (supabase as any)
    .from('vw_risk_contract_ranking')
    .select('contract_id, contrato_nome, contratada, cluster_id, score_risco, nivel_criticidade, tendencia, prob_atraso_mc')
    .order('score_risco', { ascending: false })
    .range(offset, offset + limit - 1);
  if (error) throw error;
  return (data || []) as RankingGlobal[];
}
